import React from 'react';
import PropTypes from 'prop-types';
import EventCard from 'components/events/EventCard';
import EventFeatured from 'components/events/EventFeatured';
import LoadMoreButton from 'components/common/LoadMoreButton';
import listStyles from 'styles/modules/CardList.module.css';
import styles from './GridView.module.css';

const GridView = ({ events, onLoadMore, hasMore, loadingMore }) => {
  if (events.length === 0) {
    return <div>Aucun événement disponible.</div>;
  }

  const [featuredEvent, ...otherEvents] = events;

  return (
    <div className={`global-container ${listStyles.listSection} ${styles.gridSection}`}>
      <EventFeatured event={featuredEvent} />

      <ul className={`list--none ${listStyles.grid}`}>
        {otherEvents.map((event) => (
          <EventCard
            key={event.id || event.slug}
            event={event}
          />
        ))}
      </ul>

      {hasMore && (
        <LoadMoreButton onClick={onLoadMore} disabled={loadingMore} />
      )}
    </div>
  );
};

GridView.propTypes = {
  events: PropTypes.array.isRequired,
  onLoadMore: PropTypes.func,
  hasMore: PropTypes.bool,
  loadingMore: PropTypes.bool,
};

GridView.defaultProps = {
  onLoadMore: undefined,
  hasMore: false,
  loadingMore: false,
};

export default GridView;
